import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './header';
import Sidenavbar from './sidenavbar';

const Layout = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();

    // Close the mobile menu after navigating
    useEffect(() => { setMenuOpen(false) }, [location.pathname]);

    return (
        <div className={menuOpen ? 'MenuOpen' : ''}>
            <Header onToggleMenu={() => setMenuOpen(open => !open)} />
            <Sidenavbar />
            <div className="MenuBackdrop" onClick={() => setMenuOpen(false)} />
            <div className="WrapperArea">
                <div className="WrapperBox">
                    <Outlet />
                </div>
            </div>
        </div>
    )
}

export default Layout
